import { Card } from '@payaca/ambrosia';
import { FC } from 'react';

export interface DashboardSectionEmptyProps {
  /** Section title */
  title: string;
  /** Empty state message */
  message: string;
}

const DashboardSectionEmpty: FC<DashboardSectionEmptyProps> = ({
  title,
  message,
}) => {
  return (
    <Card>
      <Card.Body>
        <h3 className="mb-4">{title}</h3>
        <p className="supporting-body text-gray-500">{message}</p>
      </Card.Body>
    </Card>
  );
};

export default DashboardSectionEmpty;
